<div class="modal-header py-2 bg-light">
  <h6 class="modal-title">Import</h6>
  <button type="button" data-bs-dismiss="modal" (click)="activeModal.dismiss()" aria-label="Close" class="btn-close"></button>
</div>
<div class="modal-body" *transloco="let t">
  <div class="process-area row">
    <div class="col-8">
      <div class="row">
        <div class="form-label col-4"><b>{{ 'common.processed'|transloco }}: </b></div>
        <div class="col-6 totalImported">{{ totalImported }}</div>
      </div>
      <div class="row">
        <div class="form-label col-4"><b>{{ 'common.total'|transloco }}: </b></div>
        <div class="col-6 totalRecord">{{ totalRecord }}</div>
      </div>
      <div class="row">
        <div class="form-label col-4"><b>{{ 'common.success'|transloco }}: </b></div>
        <div class="col-6 totalSuccess text-success">{{ totalSuccess }}</div>
      </div>
      <div class="row">
        <div class="form-label col-4"><b>{{ 'common.error'|transloco }}: </b></div>
        <div class="col-6 totalError text-danger">{{ totalError }}</div>
      </div>
      <div class="row">
        <div class="form-label col-4"><b>{{ 'common.warning'|transloco }}: </b></div>
        <div class="col-6 totalWarning text-warning">{{ totalWarning }}</div>
      </div>
    </div>

    <div class="col-2 text-center" style="font-size: 3em;">
      @if (!finish) {
        <i class="ph ph-gear excel-loading-icon"></i>
      } @else {
        <i class="ph ph-check text-success"></i>
      }
    </div>

    <div class="col-12 my-2">
      <app-progress-bar [totalPages]="totalRecord" [currentPage]="totalImported"/>
    </div>
  </div>
  <div class="detail-area row">
    <div class="col-12 my-1"><a class="detail-toggle">{{ 'common.detail'|transloco }}</a>
      <div class="detail-content">
        @if (logs.length) {
          @for (l of logs; track l) {
            <p
              [ngClass]="{
 'text-success': l.status == 1,
 'text-warning': l.status == 2,
 'text-danger': l.status == 3
 }">
              @if (isArray(l.msg)) {
                @for (m of l.msg; track m) {
                  @switch (l.status) {
                    @case (1) {
                      {{ 'common.line'|transloco }} {{ l.line }}: {{ t('common.success') }}
                    }
                    @case (2) {
                      {{ 'common.line'|transloco }} {{ l.line }}: {{ t('common.warning') }}: {{ m }}
                    }
                    @case (3) {
                      {{ 'common.line'|transloco }} {{ l.line }}: {{ t('common.error') }}: {{ m }}
                    }
                  }
                }
              } @else {
                @switch (l.status) {
                  @case (1) {
                    {{ 'common.line'|transloco }} {{ l.line }}: {{ t('common.success') }}
                  }
                  @case (2) {
                    {{ 'common.line'|transloco }} {{ l.line }}: {{ t('common.warning') }}: {{ l.msg }}
                  }
                  @case (3) {
                    {{ 'common.line'|transloco }} {{ l.line }}: {{ t('common.error') }}: {{ l.msg }}
                  }
                }
              }
            </p>
          }
        }
      </div>
    </div>
  </div>
  <div class="mt-1">
    <a (click)="saveLog()" class="cursor-pointer text-primary">
      {{ 'common.saveLogFile'|transloco }}
    </a>
  </div>
</div>
